import React from "react";
import PremiumResourcePage, { resourceMoney, resourceStatus } from "../../../Components/Dashboard/PremiumResourcePage";
import SalesOrderUpdate from "../SalesNew/SalesOrderUpdate";

function SalesOrder({ navigation }) {
  return (
    <PremiumResourcePage
      navigation={navigation}
      title="Sales Orders"
      subtitle="Track confirmed customer orders and fulfillment."
      createRoute="SalesOrderNewButton"
      createLabel="+ New Sales Order"
      fetchEndpoint="/fetchSalesOrder"
      documentType="sales_order"
      deleteEndpoint="/deleteBySalesOrderNumber/:id"
      deleteKey="salesOrderNumber"
      totalKey="total"
      renderEdit={(row, handleCancel) => (
        <SalesOrderUpdate
          salesOrderNumber={row.salesOrderNumber}
          fetchedStatus={row.status}
          handleCancel={handleCancel}
        />
      )}
      columns={[
        { key: "salesOrderDate", label: "Date" },
        { key: "salesOrderNumber", label: "Sales Order #" },
        { key: "reference", label: "Reference" },
        { key: "customerName", label: "Customer Name" },
        { key: "status", label: "Status", render: (row) => resourceStatus(row.status) },
        { key: "total", label: "Amount", className: "premium-money", render: (row) => resourceMoney(row.total) },
      ]}
    />
  );
}

export default SalesOrder;
